import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "appointment-selector" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Choose an appointment time.", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "card card-body location-card" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "location-partial__mobile-mechanic"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "Mobile mechanic service", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " You don’t need to go anywhere. Mobile mechanics come to your location and perform service there. The location you specify must allow auto repair and service to be done onsite. ", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_multi_time_selector = _resolveComponent("multi-time-selector")!
  const _component_single_time_selector = _resolveComponent("single-time-selector")!
  const _component_location_partial = _resolveComponent("location-partial")!
  const _component_location_hours = _resolveComponent("location-hours")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_spinner, {
          key: 0,
          relative: "",
          centered: ""
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.location.doesHouseCalls)
            ? (_openBlock(), _createBlock(_component_multi_time_selector, {
                key: 0,
                days: _ctx.days,
                title: `Your appointment is not confirmed until ${_ctx.location.name} selects one
          of the times you provide, or proposes another time that you agree to.`,
                "total-repair-time-hours": _ctx.totalRepairTimeHours,
                "location-name": _ctx.location.name,
                slots: _ctx.slots,
                onTimeSet: _ctx.timeSet,
                onApptPreferenceChosen: _ctx.appointmentChosen
              }, null, 8, ["days", "title", "total-repair-time-hours", "location-name", "slots", "onTimeSet", "onApptPreferenceChosen"]))
            : (_openBlock(), _createBlock(_component_single_time_selector, {
                key: 1,
                "total-repair-time-hours": _ctx.totalRepairTimeHours,
                days: _ctx.days,
                slots: _ctx.slots,
                onTimeSet: _ctx.timeSet,
                onApptPreferenceChosen: _ctx.appointmentChosen
              }, null, 8, ["total-repair-time-hours", "days", "slots", "onTimeSet", "onApptPreferenceChosen"])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_location_partial, {
                    class: "col-12",
                    location: _ctx.location
                  }, {
                    default: _withCtx(() => [
                      (_ctx.location.doesHouseCalls)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["location"]),
                  _createVNode(_component_location_hours, {
                    class: "col-12",
                    "location-hours": _ctx.location.hours
                  }, null, 8, ["location-hours"])
                ])
              ])
            ])
          ])
        ], 64))
  ]))
}